define([
  'react',
  'prop-types',
  'immutable',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, Component) => {
  const Html = Component({})(({
    onMouseEnter,
    onMouseLeave,
    html = '',
    style = Immutable.Map(),
  }) => (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="button"
      tabIndex={0}
    >
      <div
        style={style.toJS()}
        dangerouslySetInnerHTML={{ __html: html.replace(/\n/g, '') }}
      />
    </div>
  ));

  Html.propTypes = {
    html: PropTypes.string,
    style: PropTypes.instanceOf(Immutable.Map),
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
  };

  return Html;
});
